import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import InvoiceSelectedTableHeader from "./InvoiceSelectedTableHeader";
import InvoiceSelectedTableRow from "./InvoiceSelectedTableRow";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#C12B2D",
  },
});

const InvoiceItemsTable = ({ invoice }) => {
  const tableRowsCount = invoice.items.length + 2;

  return (
    <View style={styles.tableContainer}>
      <InvoiceSelectedTableHeader />
      <InvoiceSelectedTableRow items={invoice.selectedItems} />
    </View>
  );
};

export default InvoiceItemsTable;
